"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleFooter = void 0;
const toggleFooter = () => {
    const contactButton = document.querySelector('[data-ref="aui-footer.open-contact-dialog"]');
    if (contactButton != null)
        contactButton.click();
};
exports.toggleFooter = toggleFooter;
